import apiClient from "../../../utils/clients/axios";

// get all notification data
export const getAllNotificationData = async () => {
  const response = await apiClient.get(
    `/api/quality_control/master/notifications`
  );
  return response;
};
